<template>
  <v-dialog v-model="isDialogOpened" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>THÊM CÔNG VIỆC</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4">
        <v-form ref="new-task-form">
          <div class="task-title mb-4">
            <v-text-field
              v-model="title"
              label="Tên đầu mục công việc"
              class="required"
              outlined
              dense
              :rules="[$rules.required]"
              hide-details="auto"
            ></v-text-field>
          </div>
          <div class="task-content mb-4">
            <v-textarea
              v-model="content"
              label="Nội dung công việc"
              hide-details="auto"
              rows="3"
              full-width
              auto-grow
              clearable
              outlined
              dense
            ></v-textarea>
          </div>
          <div class="task-data mb-4">
            <div class="data-title">Người giao</div>
            <div class="task-creators">{{ profile.name || '' }}</div>
          </div>
          <div class="task-data mb-4">
            <div class="data-title">Người nhận</div>
            <div class="receiver-wrapper">
              <div :class="{ 'receiver-error': showReceiverError }">
                <TaskReceiverSelector
                  v-if="isDialogOpened"
                  :defaultReceivers="selectedReceivers"
                  @change="receiversChangeHandler"
                />
              </div>
              <div v-if="showReceiverError" class="receiver-error-message">Trường này không được bỏ trống</div>
            </div>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <DatePicker
                :date.sync="startTime"
                @update:date="handleStartTimeChange"
                :maxDate="endTime"
                label="Bắt đầu từ"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="6">
              <DatePicker
                :date.sync="endTime"
                @update:date="handleEndTimeChange"
                :minDate="startTime"
                label="Kết thúc trước"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <div></div>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn class="ma-2" outlined @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="addNewTask">Thêm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import { Task } from '@/plugins/api'
import DatePicker from './DatePicker.vue'
import TaskReceiverSelector from './TaskReceiverSelector.vue'

export default {
  components: { TaskReceiverSelector, DatePicker },
  props: {},
  data() {
    return {
      isDialogOpened: false,
      title: '',
      content: '',
      selectedReceivers: [],
      startTime: '',
      endTime: '',
      members: [],
      newIndex: 0,
      showReceiverError: false
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'user'])
  },
  methods: {
    ...mapActions('task', ['createTask']),
    cancel() {
      this.isDialogOpened = false
    },
    openDialog(index = 0) {
      this.isDialogOpened = true
      this.selectedReceivers = []
      this.title = ''
      this.content = ''
      this.startTime = ''
      this.endTime = ''
      this.newIndex = index
    },
    receiversChangeHandler(newReceivers) {
      this.selectedReceivers = newReceivers
      if (!isEmpty(this.selectedReceivers)) {
        this.showReceiverError = false
      }
    },
    async addNewTask() {
      try {
        if (!this.$refs['new-task-form'].validate()) {
          return
        }
        if (isEmpty(this.selectedReceivers)) {
          this.showReceiverError = true
          return
        }
        this.$loading.active = true
        const newTask = {
          title: this.title,
          content: this.content,
          creator: this.user.id,
          receivers: this.selectedReceivers,
          startTime: this.startTime,
          endTime: this.endTime,
          index: this.newIndex,
          category: 'todo',
          status: 'active'
        }
        await Task.createTasks(newTask)
        this.$emit('addTaskFinish')
        this.isDialogOpened = false
      } catch (error) {
        this.$alert.addError('Thêm công việc thất bại')
      } finally {
        this.$loading.active = false
      }
    },
    handleStartTimeChange(time) {
      this.startTime = time
    },
    handleEndTimeChange(time) {
      this.endTime = time
    }
  }
}
</script>

<style lang="scss" scoped>
.task-title {
  width: 100%;
}
.task-data {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .data-title {
    flex: 0 0 150px;
    padding: 4px 0;
  }
}
.receiver-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.receiver-error {
  border: 2px solid #fd6b6b;
  padding: 2px;
}
.receiver-error-message {
  font-size: 12px;
  color: #fd6b6b;
}
</style>
